<template lang="pug">
div
  v-tabs(v-model="tabs" hide-slider height="36" @change="")
    v-tab.text-sm.font-medium.normal-case All {{ totalCount ? `(${totalCount})` : '' }}
    v-tab.text-sm.font-medium.normal-case Selected ({{ selectedVisits ? selectedVisits.length : '0' }})

  v-card.mt-3(outlined)
    .data-table
      v-data-table.table-custom(:headers="headers" :items="visitList" item-key="id" :items-per-page="pageSize" dense hide-default-footer disable-sort :loading="isFetching" :header-props="{ sortIcon: '$yzi-triangle' }" @click:row="selectVisit")
        template(v-slot:no-data)
          .mt-16
            v-img.mx-auto(src="@/assets/images/icon_empty.png" width=80)
            .mt-2.p2.basic600--text {{ $t('no_list_available') }}
        template(v-slot:header.checked)
          yc-checkbox(v-if="!tabs" v-model="checkAll" @change="onCheckedAll")
        template(#item.checked="{ item, headers, index }")
          yc-checkbox(v-model="item.checked" @change="onChecked(item)")
        template(#item.date="{ item, headers, index }")
          div.text-xs.font-medium.neutral700--text {{ item.record_date | humanizeDate }}
        template(#item.time="{ item, headers, index }")
          div.text-xs.font-medium.neutral700--text {{ item.record_date | displayTime2 }}
        template(#item.provider="{ item, headers, index }")
          div.d-flex.align-center(v-if="item.provider")
            v-avatar.mr-1(size="16" color="neutral300")
              template(v-if="item.provider.profile_image")
                v-img(:src="`https://img.yezza.io/50x50/${item.provider.profile_image.path}`")
              v-icon(v-else color="neutral500" size="15") $yzi-user-03
            div.text-xs.font-medium.neutral700--text {{ item.provider.name }}
    v-divider
    div.d-flex.align-center.my-2.mx-3(v-if="!tabs && totalCount > pageSize")
      v-spacer
      yz-pagination(v-model="currentPage" :page-size.sync="pageSize" :count="totalCount" type="item" text="past visits" @input="pageChanged")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {},
  props: {},
  data () {
    return {
      showSearchField: false,
      isFetching: false,
      checkAll: false,
      tabs: 0,
      totalCount: 0,
      pageSize: 5,
      currentPage: 1,
      visits: [],
      selectedVisits: [],
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      consultation: 'treatment/getConsultation',
      patient: 'treatment/getPatient',
      visitFilters: 'treatment/getVisitFilters',
    }),
    headers () {
      let headers = [
        { value: 'checked', text: '', sortable: false},
        { value: 'date', text: 'Date', class: 'text-table-header'},
        { value: 'time', text: 'Time', class: 'text-table-header'},
        { value: 'provider', text: 'Provider', class: 'text-table-header'},
      ]
      return headers
    },
    visitList () {
      if (this.tabs) {
        return this.selectedVisits
      } else {
        return this.visits
      }
    },
  },
  mounted () {
    this.setData()
    this.fetchVisits()
  },
  methods: {
    ...mapActions(['showMessage']),
    setData () {
      if (this.visitFilters.visits) {
        let tempVisits = JSON.parse(JSON.stringify(this.visitFilters.visits))
        let tempSelectedVisits = JSON.parse(JSON.stringify(this.selectedVisits))
        this.selectedVisits = tempVisits
        if (JSON.stringify(this.visitFilters.visits) !== JSON.stringify(tempSelectedVisits)) {
          this.fetchVisits()
        }
      }
    },
    fetchVisits () {
      this.checkAll = false,
      this.isFetching = true
      let params = {
        page_size: this.pageSize,
        page: this.currentPage,
        fields: 'record_date,lead_id,provider',
        exclude_ids: this.consultation.lead
      }
      this.$axios.get(`/clinics/${this.company.slug}/patients/${this.patient.id}/histories`, { params })
        .then(resp => {
          this.totalCount = resp.data.count
          let data = resp.data.results
          data.forEach(visit => {
            visit.checked = false
            if (this.selectedVisits.length) {
              if (this.selectedVisits.find(f => f.lead_id === visit.lead_id)) {
                visit.checked = true
              }
            }
          })
          this.visits = data
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    pageChanged () {
      this.fetchVisits()
    },
    selectVisit (item) {
      item.checked = !item.checked
      this.onChecked(item)
    },
    onChecked (item) {
      if (item.checked) {
        this.selectedVisits.push(item)
      } else {
        this.checkAll = false
        this.$nextTick(() => {
          this.selectedVisits = this.selectedVisits.filter(f => f.lead_id !== item.lead_id)
        })
      }
    },
    onCheckedAll () {
      if (this.checkAll) {
        this.checkAllVisits()
      } else {
        this.uncheckAllVisits()
      }
    },
    checkAllVisits () {
      this.visits.forEach(visit => {
        if (!this.selectedVisits.find(selected => selected.lead_id === visit.lead_id)) {
          this.selectedVisits.push(visit)
        }
      })
      this.visits.map(m => m.checked = true)
    },
    uncheckAllVisits () {
      this.visits.forEach(visit => {
        if (visit.checked) {
          this.selectedVisits = this.selectedVisits.filter(selected => selected.lead_id !== visit.lead_id)
          visit.checked = false
        }
      })

    },
    updateFilters () {
      let obj = {
        visits: this.selectedVisits.length ? this.selectedVisits : null,
        dateRange: null,
      }
      this.$store.commit('treatment/updateVisitFilters', obj)
    }
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-data-table__wrapper table tbody tr:hover{
    cursor: pointer;
    background: var(--v-neutral200) !important; 
  }
  .table-custom {
    .v-data-table-header {
      background-color: var(--v-neutral200);
      border-radius: 10px;
    }
    .text-table-header, .v-data-table__wrapper > table > thead > tr > th {
      text-transform: none !important;
    }
    .v-data-table__wrapper {
      overflow: visible !important;
    }
  }
}
.v-tab--active {
  background-color: var(--v-neutral300);
  border-radius: 10px;
}
</style>